import displayModal from 'root/src/client/logic/modal/actions/displayModal';
import { NO_MORE_REWARD_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
export const displayNoMoreRewardModal = ({ formData }) => (dispatch) => {
    dispatch(displayModal(NO_MORE_REWARD_MODAL_MODULE_ID, { formData }));
};
